/**
 * @generated SignedSource<<b3200274f7673011236c8e672a2ac893>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserAvatar_member$data = {
  readonly avatar: {
    readonly url: URIString;
  } | null;
  readonly email: string;
  readonly name: string;
  readonly " $fragmentType": "UserAvatar_member";
};
export type UserAvatar_member$key = {
  readonly " $data"?: UserAvatar_member$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserAvatar_member">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserAvatar_member",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": "avatar",
      "args": [
        {
          "kind": "Literal",
          "name": "width",
          "value": 750
        }
      ],
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": "image(width:750)"
    }
  ],
  "type": "Member",
  "abstractKey": null
};

(node as any).hash = "9cf069b66c69b00efe4c686cdd9495a2";

export default node;
